export const propMiscModals = {
  policia: {
    title: "Registrar dados",
    heading: "Registre os dados das autoridades competentes",
    subtitle:
      "Sincronize automaticamente os check-ins da sua propriedade com as autoridades",
    entityLabel: "Nome da entidade",
    entityPlaceholder: "Selecione uma entidade",
    userLabel: "Nome de usuário",
    passwordLabel: "Senha",
    accessError:
      "Verifique suas credenciais de acesso; recomendamos não tentar mais de três vezes, ou você pode bloquear sua conta.",
    validateBtn: "Validar",
    saveBtn: "Salvar dados",
    entityRequired: "A entidade é obrigatória",
    usernameRequired: "O nome de usuário é obrigatório",
    passwordRequired: "Você deve inserir a senha",
    validateError: "Erro ao validar os dados",
    saveError: "Erro ao salvar os dados da polícia de imigração",
  },
  upgrade: {
    heading: "Faça upgrade do seu plano para continuar criando propriedades",
    message:
      "Olá! Notamos que você atingiu o limite de propriedades permitido no seu plano atual.",
    button: "Fazer upgrade do plano",
  },
};
